import React, { useEffect, useState } from 'react';
import './SEBISlider.css';

const SEBISlider = () => {
  const [sebiIndex, setSebiIndex] = useState(0);
  const sebiNumbers = [
    {
      text: "SEBI Registration No: INH000020129",
    },
    {
      text: "BSE Enlistment No.: 6528",
      logo: "/bselogo.png",
      alt: "BSE Logo"
    },
    {
      text: "SEBI Registration No: INH000020129",
    },
    {
      text: "BSE Enlistment No.: 6528",
      logo: "/bselogo.png",
      alt: "BSE Logo"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setSebiIndex((prevIndex) => (prevIndex + 1) % sebiNumbers.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [sebiNumbers.length]);

  return (
    <div className="sebi-slider-common">
      <div className="sebi-slider-content">
        <div className="sebi-slider-text">
          {sebiNumbers.map((item, index) => (
            <div
              key={index}
              className={`sebi-number ${index === sebiIndex ? 'active' : ''}`}
            >
              <span className="sebi-text">{item.text}</span>
              {item.logo && (
                <img 
                  src={item.logo} 
                  alt={item.alt} 
                  className="sebi-logo"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SEBISlider;
